import { render, staticRenderFns } from "./VTemplateDashboard.vue?vue&type=template&id=74112805&scoped=true&lang=pug&v-cloak=true"
import script from "./VTemplateDashboard.vue?vue&type=script&lang=ts"
export * from "./VTemplateDashboard.vue?vue&type=script&lang=ts"
import style0 from "./VTemplateDashboard.vue?vue&type=style&index=0&id=74112805&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74112805",
  null
  
)

/* custom blocks */
import block0 from "./RTemplateDashboard.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FTemplate%2Fviews%2FSummary%2FVTemplateDashboard.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports